import { render, staticRenderFns } from "./uploadURL-editor.vue?vue&type=template&id=26d3626e&scoped=true"
import script from "./uploadURL-editor.vue?vue&type=script&lang=js"
export * from "./uploadURL-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d3626e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26d3626e')) {
      api.createRecord('26d3626e', component.options)
    } else {
      api.reload('26d3626e', component.options)
    }
    module.hot.accept("./uploadURL-editor.vue?vue&type=template&id=26d3626e&scoped=true", function () {
      api.rerender('26d3626e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/uploadURL-editor.vue"
export default component.exports